// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//  baseUrl: 'http://kosmetikon.myqnapcloud.com:3500/',
  baseUrl: 'https://support.kosmetikon.io/',
  // baseUrl: 'https://supporttest.kosmetikon.io/',
  // baseUrl: 'http://localhost:3500/',
  version: 'v.11.1.9',
  releaseDate: '15/02/2024'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
